const BASE = ['checklist'] as const;

export const CHECKLIST_QUERY_KEYS = {
  getChecklistSubmission: (id: number) => [...BASE, 'submission', id] as const,
};
